import { Injectable } from '@angular/core';
import { FormSitecoreMapperService } from './form-site-core-mapper.service';
import { GridSitecoreMapperService } from './grid-site-core-mapper.service';
import {
  pageData,
  MappedPageData,
  Field,
  Grid,
  Badge
} from '../def/sitecore-data-def';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from '../base-data-service';
import { UCMFormSitecoreMapperService } from './ucm-form-site-core-mapper.service';
import { GlobalVariablesService } from '../global-variables.service';

@Injectable()
export class BaseSiteCoreAPIMapper extends BaseDataService {
  constructor(
    private FormSitecoreMapperService: FormSitecoreMapperService,
    private gridSitecoreMapperService: GridSitecoreMapperService,
    private ucmFormSitecoreMapperService: UCMFormSitecoreMapperService,
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  form;
  gird;
  accordion;
  data;
  messages;
  mapSiteCoreData(sitecoreFormData = null): MappedPageData {
    if (!sitecoreFormData) {
    }
    let MappedData: MappedPageData = {
      gridData: this.gridSitecoreMapperService.mapGridSettings(
        sitecoreFormData.grids
      ),
      formData: this.FormSitecoreMapperService.mapFormData(
        sitecoreFormData.forms
      ),
      accordianData: sitecoreFormData.accordians,
      data: sitecoreFormData.data,
      messages: sitecoreFormData.messages,
      media: sitecoreFormData.media,
      bound: sitecoreFormData,
      buttons: sitecoreFormData.buttons,
      UCMforms: this.ucmFormSitecoreMapperService.mapUCMFormData(
        sitecoreFormData.UCMforms
      )
    };
    return MappedData;
  }
  fetchUCMFromMappedSitecoreData(mappedData) {
    return mappedData['siteCore']['UCMforms'];
  }
  fetchFormDataFromMappedSitecoreData(mappedData, formName = ''): Field[] {
    let formData = mappedData['siteCore']['formData'];
    let fields: Field[];
    if (formName != '') {
      formData.forEach(forms => {
        if (forms.formName === formName) {
          fields = forms.fields;
        }
      });
    } else {
      return formData;
    }
    return fields;
  }

  fetchGridDataFromMappedSitecoreData(mappedData, gridName = '') {
    let gridData = mappedData['siteCore']['gridData'];
    let grid: Grid[];
    if (gridName != '') {
      gridData.forEach(gridData => {
        if (gridData.gridName === gridName) {
          grid = gridData.data;
        }
      });
    } else {
      return gridData;
    }
    return grid;
  }
  fetchDataFromMappedSitecoreData(mappedData, data = '') {
    let Data = mappedData['siteCore']['data'];
    return Data;
  }
  fetchMessageDataFromMappedSitecoreData(mappedData, messages = '') {
    let messageData = mappedData['siteCore']['messages'];
    return messageData;
  }
  fetchBadgeDataFromMappedSitecoreData(mappedData, Badge = ''): Badge {
    let badgeData = mappedData['siteCore']['accordianData'];
    return badgeData;
  }
  fetchBannerDataFromMappedSitecoreData(mappedData, Badge = '') {
    let bannerData = mappedData['siteCore']['media'];
    return bannerData;
  }
  fetchDashboardDataFromMappedSitecoreData(mappedData, Badge = '') {
    let dashboardLabels = mappedData['siteCore'];
    return dashboardLabels;
  }
  fetchBoundPolicySitecoreData(mappedData, Badge = '') {
    let boundData = mappedData['siteCore']['bound'];
    return boundData;
  }
}
